<template>
  <PflegeButton
    :ref="blok.link?.ref"
    v-editable="blok"
    :data-uid="blok._uid"
    :icon="blok.icon"
    :icon-position="blok.iconPosition"
    :label="blok.label"
    :tag="useCalcedLink?.(blok) ? defineNuxtLinkTag : 'button'"
    :target="blok.link?.target"
    :title="blok.link ? blok.link?.title : null"
    :to="useCalcedLink?.(blok)"
    :tracking-label="trackingLabel"
    :variant="blok.type"
  />
</template>

<script setup lang="ts">
import type { ButtonType, IconName, PflegeButton } from '@webcarelbj/shared-components'
import { computed, inject, ref, resolveComponent } from 'vue'
import { BlokIcon, BlokProps } from '../../types/blok'
import  { useCalcedLink } from '../../composables/calcedLink'
import { blokMainComponent, useTracking } from '../../'

export interface ButtonBlok extends BlokIcon {
  label: string
  tag: string
  target?: string
  title?: string
  icon?: IconName
  to: string
  trackingLabel?: string
  variant: string
  link?: {
    target?: string
    title?: string
    ref?: string
    cached_url?: string
    linktype?: string
    anchor?: string
  },
  type: ButtonType
  mainComponentTrackingLabel: string
}

const props = defineProps<BlokProps<ButtonBlok>>()
const { prepareClickContext, createTrackingLabel } = useTracking()
const mainComponent = inject(blokMainComponent)

const trackingLabel = computed<string>(() => {
  return `btn_${createTrackingLabel(props.blok.label)}`
})

if (mainComponent) {
  const mainComponentLabel= ref<string>(mainComponent.mainComponent.value)

  if (props.blok.mainComponentTrackingLabel?.trim().length > 0) {
    mainComponentLabel.value = props.blok.mainComponentTrackingLabel
  }
  prepareClickContext('button', mainComponentLabel.value, props.blok.label)
}

const defineNuxtLinkTag = computed(() => {
  return resolveComponent('NuxtLink')
})
</script>
